/* This function is completely auto-generated via the `pnpm bootstrap` phase of
  the app. You can re-run it when adding new localized handbook pages by running:

  pnpm run --filter=documentation create-handbook-nav

  Find the source of truth at packages/documentation/scripts/generateDocsNavigationPerLanguage.js
*/

import type { SidebarNavItem } from "./documentationNavigationUtils";

export function getDocumentationNavForLanguage(
  langRequest: string
): SidebarNavItem[] {
  const langs = ["en", "zh"];
  const lang = langs.includes(langRequest) ? langRequest : "en";
  const navigations: Record<string, SidebarNavItem[]> = {};

  navigations.en = [
    {
      title: "Get Started",
      oneline: "Quick introductions based on your background or preference.",
      id: "get-started",
      chronological: false,

      items: [
        {
          title: "TS for the New Programmer",
          id: "0-typescript-for-the-new-programmer",
          permalink: "/docs/handbook/typescript-from-scratch.html",
          oneline: "Learn TypeScript from scratch",
        },
        {
          title: "TypeScript for JS Programmers",
          id: "0-typescript-for-javascript-programmers",
          permalink: "/docs/handbook/typescript-in-5-minutes.html",
          oneline: "Learn how TypeScript extends JavaScript",
        },
        {
          title: "TS for Java/C# Programmers",
          id: "0-typescript-for-java/c#-programmers",
          permalink: "/docs/handbook/typescript-in-5-minutes-oop.html",
          oneline:
            "Learn TypeScript if you have a background in object-oriented languages",
        },
        {
          title: "TS for Functional Programmers",
          id: "0-typescript-for-functional-programmers",
          permalink: "/docs/handbook/typescript-in-5-minutes-func.html",
          oneline:
            "Learn TypeScript if you have a background in functional programming",
        },
        {
          title: "TypeScript Tooling in 5 minutes",
          id: "0-typescript-tooling-in-5-minutes",
          permalink: "/docs/handbook/typescript-tooling-in-5-minutes.html",
          oneline:
            "A tutorial to understand how to create a small website with TypeScript",
        },
      ],
    },
    {
      title: "Handbook",
      oneline: "A great first read for your daily TS work.",
      id: "handbook",
      chronological: true,

      items: [
        {
          title: "The TypeScript Handbook",
          id: "1-the-typescript-handbook",
          permalink: "/docs/handbook/intro.html",
          oneline: "Your first step to learn TypeScript",
        },
        {
          title: "The Basics",
          id: "1-the-basics",
          permalink: "/docs/handbook/2/basic-types.html",
          oneline: "Step one in learning TypeScript: The basic types.",
        },
        {
          title: "Everyday Types",
          id: "1-everyday-types",
          permalink: "/docs/handbook/2/everyday-types.html",
          oneline: "The language primitives.",
        },
        {
          title: "Narrowing",
          id: "1-narrowing",
          permalink: "/docs/handbook/2/narrowing.html",
          oneline:
            "Understand how TypeScript uses JavaScript knowledge to reduce the amount of type syntax in your projects.",
        },
        {
          title: "More on Functions",
          id: "1-more-on-functions",
          permalink: "/docs/handbook/2/functions.html",
          oneline: "Learn about how Functions work in TypeScript.",
        },
        {
          title: "Object Types",
          id: "1-object-types",
          permalink: "/docs/handbook/2/objects.html",
          oneline: "How TypeScript describes the shapes of JavaScript objects.",
        },
        {
          title: "Type Manipulation",
          id: "1-type-manipulation",
          oneline: "undefined",
          chronological: true,

          items: [
            {
              title: "Creating Types from Types",
              id: "1-creating-types-from-types",
              permalink: "/docs/handbook/2/types-from-types.html",
              oneline:
                "An overview of the ways in which you can create more types from existing types.",
            },
            {
              title: "Generics",
              id: "1-generics",
              permalink: "/docs/handbook/2/generics.html",
              oneline: "Types which take parameters",
            },
            {
              title: "Keyof Type Operator",
              id: "1-keyof-type-operator",
              permalink: "/docs/handbook/2/keyof-types.html",
              oneline: "Using the keyof operator in type contexts.",
            },
            {
              title: "Typeof Type Operator",
              id: "1-typeof-type-operator",
              permalink: "/docs/handbook/2/typeof-types.html",
              oneline: "Using the typeof operator in type contexts.",
            },
            {
              title: "Indexed Access Types",
              id: "1-indexed-access-types",
              permalink: "/docs/handbook/2/indexed-access-types.html",
              oneline: "Using Type['a'] syntax to access a subset of a type.",
            },
            {
              title: "Conditional Types",
              id: "1-conditional-types",
              permalink: "/docs/handbook/2/conditional-types.html",
              oneline:
                "Create types which act like if statements in the type system.",
            },
            {
              title: "Mapped Types",
              id: "1-mapped-types",
              permalink: "/docs/handbook/2/mapped-types.html",
              oneline: "Generating types by re-using an existing type.",
            },
            {
              title: "Template Literal Types",
              id: "1-template-literal-types",
              permalink: "/docs/handbook/2/template-literal-types.html",
              oneline:
                "Generating mapping types which change properties via template literal strings.",
            },
          ],
        },
        {
          title: "Classes",
          id: "1-classes",
          permalink: "/docs/handbook/2/classes.html",
          oneline: "How classes work in TypeScript",
        },
        {
          title: "Modules",
          id: "1-modules",
          permalink: "/docs/handbook/2/modules.html",
          oneline:
            "How JavaScript handles communicating across file boundaries.",
        },
      ],
    },
    {
      title: "Reference",
      oneline: "Deep dive reference materials.",
      id: "reference",
      chronological: false,

      items: [
        {
          title: "Utility Types",
          id: "2-utility-types",
          permalink: "/docs/handbook/utility-types.html",
          oneline: "Types which are globally included in TypeScript",
        },
        {
          title: "Cheat Sheets",
          id: "2-cheat-sheets",
          permalink: "/cheatsheets",
          oneline: "Syntax overviews for common code",
        },
        {
          title: "Decorators",
          id: "2-decorators",
          permalink: "/docs/handbook/decorators.html",
          oneline: "TypeScript Decorators overview",
        },
        {
          title: "Declaration Merging",
          id: "2-declaration-merging",
          permalink: "/docs/handbook/declaration-merging.html",
          oneline: "How merging namespaces and interfaces works",
        },
        {
          title: "Enums",
          id: "2-enums",
          permalink: "/docs/handbook/enums.html",
          oneline: "How TypeScript enums work",
        },
        {
          title: "Iterators and Generators",
          id: "2-iterators-and-generators",
          permalink: "/docs/handbook/iterators-and-generators.html",
          oneline: "How Iterators and Generators work in TypeScript",
        },
        {
          title: "JSX",
          id: "2-jsx",
          permalink: "/docs/handbook/jsx.html",
          oneline: "Using JSX with TypeScript",
        },
        {
          title: "Mixins",
          id: "2-mixins",
          permalink: "/docs/handbook/mixins.html",
          oneline: "Using the mixin pattern with TypeScript",
        },
        {
          title: "Namespaces",
          id: "2-namespaces",
          permalink: "/docs/handbook/namespaces.html",
          oneline: "How TypeScript namespaces work",
        },
        {
          title: "Namespaces and Modules",
          id: "2-namespaces-and-modules",
          permalink: "/docs/handbook/namespaces-and-modules.html",
          oneline:
            "How to organize code in TypeScript via modules or namespaces",
        },
        {
          title: "Symbols",
          id: "2-symbols",
          permalink: "/docs/handbook/symbols.html",
          oneline: "Using the JavaScript Symbol primitive in TypeScript",
        },
        {
          title: "Triple-Slash Directives",
          id: "2-triple-slash-directives",
          permalink: "/docs/handbook/triple-slash-directives.html",
          oneline: "How to use triple slash directives in TypeScript",
        },
        {
          title: "Type Compatibility",
          id: "2-type-compatibility",
          permalink: "/docs/handbook/type-compatibility.html",
          oneline: "How type-checking works in TypeScript",
        },
        {
          title: "Type Inference",
          id: "2-type-inference",
          permalink: "/docs/handbook/type-inference.html",
          oneline: "How code flow analysis works in TypeScript",
        },
        {
          title: "Variable Declaration",
          id: "2-variable-declaration",
          permalink: "/docs/handbook/variable-declarations.html",
          oneline: "How TypeScript handles variable declaration",
        },
      ],
    },
    {
      title: "Modules Reference",
      oneline: "How TypeScript models JavaScript modules.",
      id: "modules-reference",
      chronological: false,

      items: [
        {
          title: "Introduction",
          id: "3-modules---introduction",
          permalink: "/docs/handbook/modules/introduction.html",
          oneline: "How TypeScript models JavaScript modules",
        },
        {
          title: "Theory",
          id: "3-modules---theory",
          permalink: "/docs/handbook/modules/theory.html",
          oneline: "How TypeScript models JavaScript modules",
        },
        {
          title: "Guides",
          id: "3-guides",
          oneline: "undefined",
          chronological: false,

          items: [
            {
              title: "Choosing Compiler Options",
              id: "3-modules---choosing-compiler-options",
              permalink:
                "/docs/handbook/modules/guides/choosing-compiler-options.html",
              oneline:
                "How to choose compiler options that reflect your module environment",
            },
          ],
        },
        {
          title: "Reference",
          id: "3-modules---reference",
          permalink: "/docs/handbook/modules/reference.html",
          oneline: "Module syntax and compiler options reference",
        },
        {
          title: "Appendices",
          id: "3-appendices",
          oneline: "undefined",
          chronological: false,

          items: [
            {
              title: "ESM/CJS Interoperability",
              id: "3-modules---esm/cjs-interoperability",
              permalink:
                "/docs/handbook/modules/appendices/esm-cjs-interop.html",
              oneline:
                "A detailed look at interoperability between ES modules and CommonJS modules",
            },
          ],
        },
      ],
    },
    {
      title: "Tutorials",
      oneline: "Using TypeScript in several environments.",
      id: "tutorials",
      chronological: false,

      items: [
        {
          title: "ASP.NET Core",
          id: "4-asp.net-core",
          permalink: "/docs/handbook/asp-net-core.html",
          oneline: "Using TypeScript in ASP.NET Core",
        },
        {
          title: "Gulp",
          id: "4-gulp",
          permalink: "/docs/handbook/gulp.html",
          oneline: "Using TypeScript with Gulp",
        },
        {
          title: "DOM Manipulation",
          id: "4-dom-manipulation",
          permalink: "/docs/handbook/dom-manipulation.html",
          oneline: "Using the DOM with TypeScript",
        },
        {
          title: "Migrating from JavaScript",
          id: "4-migrating-from-javascript",
          permalink: "/docs/handbook/migrating-from-javascript.html",
          oneline: "How to migrate from JavaScript to TypeScript",
        },
        {
          title: "Using Babel with TypeScript",
          id: "4-using-babel-with-typescript",
          permalink: "/docs/handbook/babel-with-typescript.html",
          oneline: "How to create a hybrid Babel + TypeScript project",
        },
      ],
    },
    {
      title: "What's New",
      oneline:
        "Find out how TypeScript has evolved and what's new in the releases.",
      id: "what's-new",
      chronological: false,

      items: [
        {
          title: "TypeScript 5.8",
          id: "5-typescript-5.8",
          permalink: "/docs/handbook/release-notes/typescript-5-8.html",
          oneline: "TypeScript 5.8 Release Notes",
        },
        {
          title: "TypeScript 5.7",
          id: "5-typescript-5.7",
          permalink: "/docs/handbook/release-notes/typescript-5-7.html",
          oneline: "TypeScript 5.7 Release Notes",
        },
        {
          title: "TypeScript 5.6",
          id: "5-typescript-5.6",
          permalink: "/docs/handbook/release-notes/typescript-5-6.html",
          oneline: "TypeScript 5.6 Release Notes",
        },
        {
          title: "TypeScript 5.5",
          id: "5-typescript-5.5",
          permalink: "/docs/handbook/release-notes/typescript-5-5.html",
          oneline: "TypeScript 5.5 Release Notes",
        },
        {
          title: "TypeScript 5.4",
          id: "5-typescript-5.4",
          permalink: "/docs/handbook/release-notes/typescript-5-4.html",
          oneline: "TypeScript 5.4 Release Notes",
        },
        {
          title: "TypeScript 5.3",
          id: "5-typescript-5.3",
          permalink: "/docs/handbook/release-notes/typescript-5-3.html",
          oneline: "TypeScript 5.3 Release Notes",
        },
        {
          title: "TypeScript 5.2",
          id: "5-typescript-5.2",
          permalink: "/docs/handbook/release-notes/typescript-5-2.html",
          oneline: "TypeScript 5.2 Release Notes",
        },
        {
          title: "TypeScript 5.1",
          id: "5-typescript-5.1",
          permalink: "/docs/handbook/release-notes/typescript-5-1.html",
          oneline: "TypeScript 5.1 Release Notes",
        },
        {
          title: "TypeScript 5.0",
          id: "5-typescript-5.0",
          permalink: "/docs/handbook/release-notes/typescript-5-0.html",
          oneline: "TypeScript 5.0 Release Notes",
        },
        {
          title: "TypeScript 4.9",
          id: "5-typescript-4.9",
          permalink: "/docs/handbook/release-notes/typescript-4-9.html",
          oneline: "TypeScript 4.9 Release Notes",
        },
        {
          title: "TypeScript 4.8",
          id: "5-typescript-4.8",
          permalink: "/docs/handbook/release-notes/typescript-4-8.html",
          oneline: "TypeScript 4.8 Release Notes",
        },
        {
          title: "TypeScript 4.7",
          id: "5-typescript-4.7",
          permalink: "/docs/handbook/release-notes/typescript-4-7.html",
          oneline: "TypeScript 4.7 Release Notes",
        },
        {
          title: "TypeScript 4.6",
          id: "5-typescript-4.6",
          permalink: "/docs/handbook/release-notes/typescript-4-6.html",
          oneline: "TypeScript 4.6 Release Notes",
        },
        {
          title: "TypeScript 4.5",
          id: "5-typescript-4.5",
          permalink: "/docs/handbook/release-notes/typescript-4-5.html",
          oneline: "TypeScript 4.5 Release Notes",
        },
        {
          title: "TypeScript 4.4",
          id: "5-typescript-4.4",
          permalink: "/docs/handbook/release-notes/typescript-4-4.html",
          oneline: "TypeScript 4.4 Release Notes",
        },
        {
          title: "TypeScript 4.3",
          id: "5-typescript-4.3",
          permalink: "/docs/handbook/release-notes/typescript-4-3.html",
          oneline: "TypeScript 4.3 Release Notes",
        },
        {
          title: "TypeScript 4.2",
          id: "5-typescript-4.2",
          permalink: "/docs/handbook/release-notes/typescript-4-2.html",
          oneline: "TypeScript 4.2 Release Notes",
        },
        {
          title: "TypeScript 4.1",
          id: "5-typescript-4.1",
          permalink: "/docs/handbook/release-notes/typescript-4-1.html",
          oneline: "TypeScript 4.1 Release Notes",
        },
        {
          title: "TypeScript 4.0",
          id: "5-typescript-4.0",
          permalink: "/docs/handbook/release-notes/typescript-4-0.html",
          oneline: "TypeScript 4.0 Release Notes",
        },
        {
          title: "TypeScript 3.9",
          id: "5-typescript-3.9",
          permalink: "/docs/handbook/release-notes/typescript-3-9.html",
          oneline: "TypeScript 3.9 Release Notes",
        },
        {
          title: "TypeScript 3.8",
          id: "5-typescript-3.8",
          permalink: "/docs/handbook/release-notes/typescript-3-8.html",
          oneline: "TypeScript 3.8 Release Notes",
        },
        {
          title: "TypeScript 3.7",
          id: "5-typescript-3.7",
          permalink: "/docs/handbook/release-notes/typescript-3-7.html",
          oneline: "TypeScript 3.7 Release Notes",
        },
        {
          title: "TypeScript 3.6",
          id: "5-typescript-3.6",
          permalink: "/docs/handbook/release-notes/typescript-3-6.html",
          oneline: "TypeScript 3.6 Release Notes",
        },
        {
          title: "TypeScript 3.5",
          id: "5-typescript-3.5",
          permalink: "/docs/handbook/release-notes/typescript-3-5.html",
          oneline: "TypeScript 3.5 Release Notes",
        },
        {
          title: "TypeScript 3.4",
          id: "5-typescript-3.4",
          permalink: "/docs/handbook/release-notes/typescript-3-4.html",
          oneline: "TypeScript 3.4 Release Notes",
        },
        {
          title: "TypeScript 3.3",
          id: "5-typescript-3.3",
          permalink: "/docs/handbook/release-notes/typescript-3-3.html",
          oneline: "TypeScript 3.3 Release Notes",
        },
        {
          title: "TypeScript 3.2",
          id: "5-typescript-3.2",
          permalink: "/docs/handbook/release-notes/typescript-3-2.html",
          oneline: "TypeScript 3.2 Release Notes",
        },
        {
          title: "TypeScript 3.1",
          id: "5-typescript-3.1",
          permalink: "/docs/handbook/release-notes/typescript-3-1.html",
          oneline: "TypeScript 3.1 Release Notes",
        },
        {
          title: "TypeScript 3.0",
          id: "5-typescript-3.0",
          permalink: "/docs/handbook/release-notes/typescript-3-0.html",
          oneline: "TypeScript 3.0 Release Notes",
        },
        {
          title: "TypeScript 2.9",
          id: "5-typescript-2.9",
          permalink: "/docs/handbook/release-notes/typescript-2-9.html",
          oneline: "TypeScript 2.9 Release Notes",
        },
        {
          title: "TypeScript 2.8",
          id: "5-typescript-2.8",
          permalink: "/docs/handbook/release-notes/typescript-2-8.html",
          oneline: "TypeScript 2.8 Release Notes",
        },
        {
          title: "TypeScript 2.7",
          id: "5-typescript-2.7",
          permalink: "/docs/handbook/release-notes/typescript-2-7.html",
          oneline: "TypeScript 2.7 Release Notes",
        },
        {
          title: "TypeScript 2.6",
          id: "5-typescript-2.6",
          permalink: "/docs/handbook/release-notes/typescript-2-6.html",
          oneline: "TypeScript 2.6 Release Notes",
        },
        {
          title: "TypeScript 2.5",
          id: "5-typescript-2.5",
          permalink: "/docs/handbook/release-notes/typescript-2-5.html",
          oneline: "TypeScript 2.5 Release Notes",
        },
        {
          title: "TypeScript 2.4",
          id: "5-typescript-2.4",
          permalink: "/docs/handbook/release-notes/typescript-2-4.html",
          oneline: "TypeScript 2.4 Release Notes",
        },
        {
          title: "TypeScript 2.3",
          id: "5-typescript-2.3",
          permalink: "/docs/handbook/release-notes/typescript-2-3.html",
          oneline: "TypeScript 2.3 Release Notes",
        },
        {
          title: "TypeScript 2.2",
          id: "5-typescript-2.2",
          permalink: "/docs/handbook/release-notes/typescript-2-2.html",
          oneline: "TypeScript 2.2 Release Notes",
        },
        {
          title: "TypeScript 2.1",
          id: "5-typescript-2.1",
          permalink: "/docs/handbook/release-notes/typescript-2-1.html",
          oneline: "TypeScript 2.1 Release Notes",
        },
        {
          title: "TypeScript 2.0",
          id: "5-typescript-2.0",
          permalink: "/docs/handbook/release-notes/typescript-2-0.html",
          oneline: "TypeScript 2.0 Release Notes",
        },
        {
          title: "TypeScript 1.8",
          id: "5-typescript-1.8",
          permalink: "/docs/handbook/release-notes/typescript-1-8.html",
          oneline: "TypeScript 1.8 Release Notes",
        },
        {
          title: "TypeScript 1.7",
          id: "5-typescript-1.7",
          permalink: "/docs/handbook/release-notes/typescript-1-7.html",
          oneline: "TypeScript 1.7 Release Notes",
        },
        {
          title: "TypeScript 1.6",
          id: "5-typescript-1.6",
          permalink: "/docs/handbook/release-notes/typescript-1-6.html",
          oneline: "TypeScript 1.6 Release Notes",
        },
        {
          title: "TypeScript 1.5",
          id: "5-typescript-1.5",
          permalink: "/docs/handbook/release-notes/typescript-1-5.html",
          oneline: "TypeScript 1.5 Release Notes",
        },
        {
          title: "TypeScript 1.4",
          id: "5-typescript-1.4",
          permalink: "/docs/handbook/release-notes/typescript-1-4.html",
          oneline: "TypeScript 1.3 Release Notes",
        },
        {
          title: "TypeScript 1.3",
          id: "5-typescript-1.3",
          permalink: "/docs/handbook/release-notes/typescript-1-3.html",
          oneline: "TypeScript 1.3 Release Notes",
        },
        {
          title: "TypeScript 1.1",
          id: "5-typescript-1.1",
          permalink: "/docs/handbook/release-notes/typescript-1-1.html",
          oneline: "TypeScript 1.1 Release Notes",
        },
      ],
    },
    {
      title: "Declaration Files",
      oneline:
        "Learn how to write declaration files to describe existing JavaScript. Important for DefinitelyTyped contributions.",
      id: "declaration-files",
      chronological: true,

      items: [
        {
          title: "Introduction",
          id: "6-introduction",
          permalink: "/docs/handbook/declaration-files/introduction.html",
          oneline:
            "How to write a high-quality TypeScript Declaration (d.ts) file",
        },
        {
          title: "Declaration Reference",
          id: "6-declaration-reference",
          permalink: "/docs/handbook/declaration-files/by-example.html",
          oneline: "How to create a d.ts file for a module",
        },
        {
          title: "Library Structures",
          id: "6-library-structures",
          permalink: "/docs/handbook/declaration-files/library-structures.html",
          oneline: "How to structure your d.ts files",
        },
        {
          title: ".d.ts Templates",
          id: "6-.d.ts-templates",
          oneline: "undefined",
          chronological: false,

          items: [
            {
              title: "Modules .d.ts",
              id: "6-modules-.d.ts",
              permalink:
                "/docs/handbook/declaration-files/templates/module-d-ts.html",
              oneline: "undefined",
            },
            {
              title: "Module: Plugin",
              id: "6-module:-plugin",
              permalink:
                "/docs/handbook/declaration-files/templates/module-plugin-d-ts.html",
              oneline: "undefined",
            },
            {
              title: "Module: Class",
              id: "6-module:-class",
              permalink:
                "/docs/handbook/declaration-files/templates/module-class-d-ts.html",
              oneline: "undefined",
            },
            {
              title: "Module: Function",
              id: "6-module:-function",
              permalink:
                "/docs/handbook/declaration-files/templates/module-function-d-ts.html",
              oneline: "undefined",
            },
            {
              title: "Global .d.ts",
              id: "6-global-.d.ts",
              permalink:
                "/docs/handbook/declaration-files/templates/global-d-ts.html",
              oneline: "undefined",
            },
            {
              title: "Global: Modifying Module",
              id: "6-global:-modifying-module",
              permalink:
                "/docs/handbook/declaration-files/templates/global-modifying-module-d-ts.html",
              oneline: "undefined",
            },
          ],
        },
        {
          title: "Do's and Don'ts",
          id: "6-do's-and-don'ts",
          permalink: "/docs/handbook/declaration-files/do-s-and-don-ts.html",
          oneline: "Recommendations for writing d.ts files",
        },
        {
          title: "Deep Dive",
          id: "6-deep-dive",
          permalink: "/docs/handbook/declaration-files/deep-dive.html",
          oneline: "How do d.ts files work, a deep dive",
        },
        {
          title: "Publishing",
          id: "6-publishing",
          permalink: "/docs/handbook/declaration-files/publishing.html",
          oneline: "How to get your d.ts files to users",
        },
        {
          title: "Consumption",
          id: "6-consumption",
          permalink: "/docs/handbook/declaration-files/consumption.html",
          oneline: "How to download d.ts files for your project",
        },
      ],
    },
    {
      title: "JavaScript",
      oneline: "How to use TypeScript-powered JavaScript tooling.",
      id: "javascript",
      chronological: true,

      items: [
        {
          title: "JS Projects Utilizing TypeScript",
          id: "7-js-projects-utilizing-typescript",
          permalink: "/docs/handbook/intro-to-js-ts.html",
          oneline:
            "How to add type checking to JavaScript files using TypeScript",
        },
        {
          title: "Type Checking JavaScript Files",
          id: "7-type-checking-javascript-files",
          permalink: "/docs/handbook/type-checking-javascript-files.html",
          oneline:
            "How to add type checking to JavaScript files using TypeScript",
        },
        {
          title: "JSDoc Reference",
          id: "7-jsdoc-reference",
          permalink: "/docs/handbook/jsdoc-supported-types.html",
          oneline: "What JSDoc does TypeScript-powered JavaScript support?",
        },
        {
          title: "Creating .d.ts Files from .js files",
          id: "7-creating-.d.ts-files-from-.js-files",
          permalink: "/docs/handbook/declaration-files/dts-from-js.html",
          oneline: "How to add d.ts generation to JavaScript projects",
        },
      ],
    },
    {
      title: "Project Configuration",
      oneline: "Compiler configuration reference.",
      id: "project-configuration",
      chronological: false,

      items: [
        {
          title: "What is a tsconfig.json",
          id: "8-what-is-a-tsconfig.json",
          permalink: "/docs/handbook/tsconfig-json.html",
          oneline: "Learn about how a TSConfig works",
        },
        {
          title: "Compiler Options in MSBuild",
          id: "8-compiler-options-in-msbuild",
          permalink: "/docs/handbook/compiler-options-in-msbuild.html",
          oneline: "Which compiler options are available in MSBuild projects.",
        },
        {
          title: "TSConfig Reference",
          id: "8-tsconfig-reference",
          permalink: "/tsconfig",
          oneline: "The page covering every TSConfig option",
        },
        {
          title: "tsc CLI Options",
          id: "8-tsc-cli-options",
          permalink: "/docs/handbook/compiler-options.html",
          oneline:
            "A very high-level overview of the CLI compiler options for tsc",
        },
        {
          title: "Project References",
          id: "8-project-references",
          permalink: "/docs/handbook/project-references.html",
          oneline: "How to split up a large TypeScript project",
        },
        {
          title: "Integrating with Build Tools",
          id: "8-integrating-with-build-tools",
          permalink: "/docs/handbook/integrating-with-build-tools.html",
          oneline: "How to use TypeScript with other build tools",
        },
        {
          title: "Configuring Watch",
          id: "8-configuring-watch",
          permalink: "/docs/handbook/configuring-watch.html",
          oneline: "How to configure the watch mode of TypeScript",
        },
        {
          title: "Nightly Builds",
          id: "8-nightly-builds",
          permalink: "/docs/handbook/nightly-builds.html",
          oneline: "How to use a nightly build of TypeScript",
        },
      ],
    },
  ];
  navigations.zh = [
    {
      title: "Get Started",
      oneline: "Quick introductions based on your background or preference.",
      id: "get-started",
      chronological: false,

      items: [
        {
          title: "面向编程初学者的 TS",
          id: "0-面向编程初学者的-typescript",
          permalink: "/zh/docs/handbook/typescript-from-scratch.html",
          oneline: "从零开始学习 TypeScript",
        },
        {
          title: "为 JS 程序员准备的 TypeScript",
          id: "0-为-javascript-程序员准备的-typescript",
          permalink: "/zh/docs/handbook/typescript-in-5-minutes.html",
          oneline: "学习 TypeScript 对 Javascript 的扩展",
        },
        {
          title: "为 Java/C# Programmers 准备的 TS",
          id: "0-为-java/c#-programmers-准备的-typescript",
          permalink: "/zh/docs/handbook/typescript-in-5-minutes-oop.html",
          oneline: "如果你有面向对象语言的背景，请学习 TypeScript",
        },
        {
          title: "面向函数式编程者的 TypeScript",
          id: "0-面向函数式编程者的-typescript",
          permalink: "/zh/docs/handbook/typescript-in-5-minutes-func.html",
          oneline: "如果你有函数式编程背景，就来学习 TypeScript 吧",
        },
        {
          title: "5 分钟了解 TypeScript 工具",
          id: "0-5-分钟了解-typescript-工具",
          permalink: "/zh/docs/handbook/typescript-tooling-in-5-minutes.html",
          oneline: "一个教程，帮助你了解如何使用 TypeScript 创建简单的网站",
        },
      ],
    },
    {
      title: "Handbook",
      oneline: "A great first read for your daily TS work.",
      id: "handbook",
      chronological: true,

      items: [
        {
          title: "TypeScript 手册",
          id: "1-typescript-手册",
          permalink: "/zh/docs/handbook/intro.html",
          oneline: "学习 TypeScript 的第一步",
        },
        {
          title: "基础",
          id: "1-基础",
          permalink: "/zh/docs/handbook/2/basic-types.html",
          oneline: "学习 TypeScript 的第一步：基本类型",
        },
        {
          title: "常见类型",
          id: "1-常见类型",
          permalink: "/zh/docs/handbook/2/everyday-types.html",
          oneline: "语言基本类型",
        },
        {
          title: "缩小类型范围",
          id: "1-缩小类型范围",
          permalink: "/zh/docs/handbook/2/narrowing.html",
          oneline:
            "了解 TypeScript 如何利用 JavaScript 的知识来减少项目中的类型语法量",
        },
        {
          title: "函数进阶",
          id: "1-函数进阶",
          permalink: "/zh/docs/handbook/2/functions.html",
          oneline: "学习 TypeScript 中函数的工作原理",
        },
        {
          title: "对象类型",
          id: "1-对象类型",
          permalink: "/zh/docs/handbook/2/objects.html",
          oneline: "TypeScript 描述 JavaScript 对象的方式",
        },
        {
          title: "Type Manipulation",
          id: "1-type-manipulation",
          oneline: "undefined",
          chronological: true,

          items: [
            {
              title: "用现有类型创建新类型",
              id: "1-用现有类型创建新类型",
              permalink: "/zh/docs/handbook/2/types-from-types.html",
              oneline: "概述如何从现有的类型创建更多的类型",
            },
            {
              title: "泛型",
              id: "1-泛型",
              permalink: "/zh/docs/handbook/2/generics.html",
              oneline: "带有参数的类型",
            },
            {
              title: "keyof 类型运算符",
              id: "1-keyof-类型运算符",
              permalink: "/zh/docs/handbook/2/keyof-types.html",
              oneline: "在类型上下文中使用 keyof 运算符。",
            },
            {
              title: "typeof 类型运算符",
              id: "1-typeof-类型运算符",
              permalink: "/zh/docs/handbook/2/typeof-types.html",
              oneline: "在类型上下文中使用 typeof 运算符。",
            },
            {
              title: "索引访问类型",
              id: "1-索引访问类型",
              permalink: "/zh/docs/handbook/2/indexed-access-types.html",
              oneline: "使用 Type['a'] 语法访问类型的子集",
            },
            {
              title: "条件类型",
              id: "1-条件类型",
              permalink: "/zh/docs/handbook/2/conditional-types.html",
              oneline: "创建类似于类型系统中 if 语句的类型",
            },
            {
              title: "映射类型",
              id: "1-映射类型",
              permalink: "/zh/docs/handbook/2/mapped-types.html",
              oneline: "通过重用现有类型生成类型。",
            },
            {
              title: "模板字面类型",
              id: "1-模板字面类型",
              permalink: "/zh/docs/handbook/2/template-literal-types.html",
              oneline: "通过模板字面字符串生成修改属性的映射类型。",
            },
          ],
        },
        {
          title: "类",
          id: "1-类",
          permalink: "/zh/docs/handbook/2/classes.html",
          oneline: "TypeScript 中的类是如何工作的",
        },
        {
          title: "模块",
          id: "1-模块",
          permalink: "/zh/docs/handbook/2/modules.html",
          oneline: "JavaScript 处理跨文件通信的方式",
        },
      ],
    },
    {
      title: "Reference",
      oneline: "Deep dive reference materials.",
      id: "reference",
      chronological: false,

      items: [
        {
          title: "Utility Types",
          id: "2-utility-types",
          permalink: "/zh/docs/handbook/utility-types.html",
          oneline: "Types which are globally included in TypeScript",
        },
        {
          title: "Cheat Sheets",
          id: "2-cheat-sheets",
          permalink: "/cheatsheets",
          oneline: "Syntax overviews for common code",
        },
        {
          title: "Decorators",
          id: "2-decorators",
          permalink: "/zh/docs/handbook/decorators.html",
          oneline: "TypeScript Decorators overview",
        },
        {
          title: "Declaration Merging",
          id: "2-declaration-merging",
          permalink: "/zh/docs/handbook/declaration-merging.html",
          oneline: "How merging namespaces and interfaces works",
        },
        {
          title: "Enums",
          id: "2-enums",
          permalink: "/zh/docs/handbook/enums.html",
          oneline: "TypeScript enum 是如何工作的",
        },
        {
          title: "Iterators and Generators",
          id: "2-iterators-and-generators",
          permalink: "/zh/docs/handbook/iterators-and-generators.html",
          oneline: "How Iterators and Generators work in TypeScript",
        },
        {
          title: "JSX",
          id: "2-jsx",
          permalink: "/zh/docs/handbook/jsx.html",
          oneline: "将 JSX 与 TypeScript 结合使用",
        },
        {
          title: "mixin",
          id: "2-mixin",
          permalink: "/zh/docs/handbook/mixins.html",
          oneline: "在 TypeScript 中使用 mixin",
        },
        {
          title: "Namespaces",
          id: "2-namespaces",
          permalink: "/zh/docs/handbook/namespaces.html",
          oneline: "How TypeScript namespaces work",
        },
        {
          title: "Namespaces and Modules",
          id: "2-namespaces-and-modules",
          permalink: "/zh/docs/handbook/namespaces-and-modules.html",
          oneline:
            "How to organize code in TypeScript via modules or namespaces",
        },
        {
          title: "Symbol",
          id: "2-symbol",
          permalink: "/zh/docs/handbook/symbols.html",
          oneline: "在 TypeScript 中使用 JavaScript 的 Symbol 原始数据类型",
        },
        {
          title: "三斜线指令",
          id: "2-三斜线指令",
          permalink: "/zh/docs/handbook/triple-slash-directives.html",
          oneline: "如何在 TypeScript 中使用三斜线指令",
        },
        {
          title: "Type Compatibility",
          id: "2-type-compatibility",
          permalink: "/zh/docs/handbook/type-compatibility.html",
          oneline: "How type-checking works in TypeScript",
        },
        {
          title: "Type Inference",
          id: "2-type-inference",
          permalink: "/zh/docs/handbook/type-inference.html",
          oneline: "How code flow analysis works in TypeScript",
        },
        {
          title: "变量声明",
          id: "2-变量声明",
          permalink: "/zh/docs/handbook/variable-declarations.html",
          oneline: "TypeScript 如何处理变量声明",
        },
      ],
    },
    {
      title: "Modules Reference",
      oneline: "How TypeScript models JavaScript modules.",
      id: "modules-reference",
      chronological: false,

      items: [
        {
          title: "简介",
          id: "3-模块——简介",
          permalink: "/zh/docs/handbook/modules/introduction.html",
          oneline: "TypeScript 如何处理 JavaScript 模块",
        },
        {
          title: "理论",
          id: "3-模块——理论",
          permalink: "/zh/docs/handbook/modules/theory.html",
          oneline: "TypeScript 处理 JavaScript 模块的方式",
        },
        {
          title: "Guides",
          id: "3-guides",
          oneline: "undefined",
          chronological: false,

          items: [
            {
              title: "选择编译器选项",
              id: "3-模块——选择编译器选项",
              permalink:
                "/zh/docs/handbook/modules/guides/choosing-compiler-options.html",
              oneline: "如何选择反映模块环境的编译器选项",
            },
          ],
        },
        {
          title: "Reference",
          id: "3-模块——参考",
          permalink: "/zh/docs/handbook/modules/reference.html",
          oneline: "模块语法和编译器选项参考",
        },
        {
          title: "Appendices",
          id: "3-appendices",
          oneline: "undefined",
          chronological: false,

          items: [
            {
              title: "ESM/CJS 互操作性",
              id: "3-模块——esm/cjs-互操作性",
              permalink:
                "/zh/docs/handbook/modules/appendices/esm-cjs-interop.html",
              oneline: "对 ES 模块和 CommonJS 模块之间的互操作性进行详细介绍",
            },
          ],
        },
      ],
    },
    {
      title: "Tutorials",
      oneline: "Using TypeScript in several environments.",
      id: "tutorials",
      chronological: false,

      items: [
        {
          title: "ASP.NET Core",
          id: "4-asp.net-core",
          permalink: "/zh/docs/handbook/asp-net-core.html",
          oneline: "在 ASP.NET Core 中使用 TypeScript",
        },
        {
          title: "Gulp",
          id: "4-gulp",
          permalink: "/zh/docs/handbook/gulp.html",
          oneline: "使用 Gulp 和 TypeScript",
        },
        {
          title: "对 DOM 的操作",
          id: "4-对-dom-的操作",
          permalink: "/zh/docs/handbook/dom-manipulation.html",
          oneline: "使用 TypeScript 操作 DOM",
        },
        {
          title: "从 JavaScript 迁移",
          id: "4-从-javascript-迁移",
          permalink: "/zh/docs/handbook/migrating-from-javascript.html",
          oneline: "如何从 JavaScript 迁移到 TypeScript",
        },
        {
          title: "Babel 搭配 TypeScript",
          id: "4-babel-搭配-typescript",
          permalink: "/zh/docs/handbook/babel-with-typescript.html",
          oneline: "如何创建一个 Babel + TypeScript 的混合项目",
        },
      ],
    },
    {
      title: "What's New",
      oneline:
        "Find out how TypeScript has evolved and what's new in the releases.",
      id: "what's-new",
      chronological: false,

      items: [
        {
          title: "TypeScript 5.8",
          id: "5-typescript-5.8",
          permalink: "/docs/handbook/release-notes/typescript-5-8.html",
          oneline: "TypeScript 5.8 Release Notes",
        },
        {
          title: "TypeScript 5.7",
          id: "5-typescript-5.7",
          permalink: "/docs/handbook/release-notes/typescript-5-7.html",
          oneline: "TypeScript 5.7 Release Notes",
        },
        {
          title: "TypeScript 5.6",
          id: "5-typescript-5.6",
          permalink: "/docs/handbook/release-notes/typescript-5-6.html",
          oneline: "TypeScript 5.6 Release Notes",
        },
        {
          title: "TypeScript 5.5",
          id: "5-typescript-5.5",
          permalink: "/docs/handbook/release-notes/typescript-5-5.html",
          oneline: "TypeScript 5.5 Release Notes",
        },
        {
          title: "TypeScript 5.4",
          id: "5-typescript-5.4",
          permalink: "/docs/handbook/release-notes/typescript-5-4.html",
          oneline: "TypeScript 5.4 Release Notes",
        },
        {
          title: "TypeScript 5.3",
          id: "5-typescript-5.3",
          permalink: "/zh/docs/handbook/release-notes/typescript-5-3.html",
          oneline: "TypeScript 5.3 Release Notes",
        },
        {
          title: "TypeScript 5.2",
          id: "5-typescript-5.2",
          permalink: "/zh/docs/handbook/release-notes/typescript-5-2.html",
          oneline: "TypeScript 5.2 Release Notes",
        },
        {
          title: "TypeScript 5.1",
          id: "5-typescript-5.1",
          permalink: "/zh/docs/handbook/release-notes/typescript-5-1.html",
          oneline: "TypeScript 5.1 Release Notes",
        },
        {
          title: "TypeScript 5.0",
          id: "5-typescript-5.0",
          permalink: "/zh/docs/handbook/release-notes/typescript-5-0.html",
          oneline: "TypeScript 5.0 Release Notes",
        },
        {
          title: "TypeScript 4.9",
          id: "5-typescript-4.9",
          permalink: "/zh/docs/handbook/release-notes/typescript-4-9.html",
          oneline: "TypeScript 4.9 Release Notes",
        },
        {
          title: "TypeScript 4.8",
          id: "5-typescript-4.8",
          permalink: "/zh/docs/handbook/release-notes/typescript-4-8.html",
          oneline: "TypeScript 4.8 Release Notes",
        },
        {
          title: "TypeScript 4.7",
          id: "5-typescript-4.7",
          permalink: "/zh/docs/handbook/release-notes/typescript-4-7.html",
          oneline: "TypeScript 4.7 Release Notes",
        },
        {
          title: "TypeScript 4.6",
          id: "5-typescript-4.6",
          permalink: "/zh/docs/handbook/release-notes/typescript-4-6.html",
          oneline: "TypeScript 4.6 Release Notes",
        },
        {
          title: "TypeScript 4.5",
          id: "5-typescript-4.5",
          permalink: "/zh/docs/handbook/release-notes/typescript-4-5.html",
          oneline: "TypeScript 4.5 Release Notes",
        },
        {
          title: "TypeScript 4.4",
          id: "5-typescript-4.4",
          permalink: "/zh/docs/handbook/release-notes/typescript-4-4.html",
          oneline: "TypeScript 4.4 Release Notes",
        },
        {
          title: "TypeScript 4.3",
          id: "5-typescript-4.3",
          permalink: "/zh/docs/handbook/release-notes/typescript-4-3.html",
          oneline: "TypeScript 4.3 Release Notes",
        },
        {
          title: "TypeScript 4.2",
          id: "5-typescript-4.2",
          permalink: "/zh/docs/handbook/release-notes/typescript-4-2.html",
          oneline: "TypeScript 4.2 Release Notes",
        },
        {
          title: "TypeScript 4.1",
          id: "5-typescript-4.1",
          permalink: "/zh/docs/handbook/release-notes/typescript-4-1.html",
          oneline: "TypeScript 4.1 Release Notes",
        },
        {
          title: "TypeScript 4.0",
          id: "5-typescript-4.0",
          permalink: "/zh/docs/handbook/release-notes/typescript-4-0.html",
          oneline: "TypeScript 4.0 Release Notes",
        },
        {
          title: "TypeScript 3.9",
          id: "5-typescript-3.9",
          permalink: "/zh/docs/handbook/release-notes/typescript-3-9.html",
          oneline: "TypeScript 3.9 Release Notes",
        },
        {
          title: "TypeScript 3.8",
          id: "5-typescript-3.8",
          permalink: "/zh/docs/handbook/release-notes/typescript-3-8.html",
          oneline: "TypeScript 3.8 Release Notes",
        },
        {
          title: "TypeScript 3.7",
          id: "5-typescript-3.7",
          permalink: "/zh/docs/handbook/release-notes/typescript-3-7.html",
          oneline: "TypeScript 3.7 Release Notes",
        },
        {
          title: "TypeScript 3.6",
          id: "5-typescript-3.6",
          permalink: "/zh/docs/handbook/release-notes/typescript-3-6.html",
          oneline: "TypeScript 3.6 Release Notes",
        },
        {
          title: "TypeScript 3.5",
          id: "5-typescript-3.5",
          permalink: "/zh/docs/handbook/release-notes/typescript-3-5.html",
          oneline: "TypeScript 3.5 Release Notes",
        },
        {
          title: "TypeScript 3.4",
          id: "5-typescript-3.4",
          permalink: "/zh/docs/handbook/release-notes/typescript-3-4.html",
          oneline: "TypeScript 3.4 Release Notes",
        },
        {
          title: "TypeScript 3.3",
          id: "5-typescript-3.3",
          permalink: "/zh/docs/handbook/release-notes/typescript-3-3.html",
          oneline: "TypeScript 3.3 Release Notes",
        },
        {
          title: "TypeScript 3.2",
          id: "5-typescript-3.2",
          permalink: "/zh/docs/handbook/release-notes/typescript-3-2.html",
          oneline: "TypeScript 3.2 Release Notes",
        },
        {
          title: "TypeScript 3.1",
          id: "5-typescript-3.1",
          permalink: "/zh/docs/handbook/release-notes/typescript-3-1.html",
          oneline: "TypeScript 3.1 Release Notes",
        },
        {
          title: "TypeScript 3.0",
          id: "5-typescript-3.0",
          permalink: "/zh/docs/handbook/release-notes/typescript-3-0.html",
          oneline: "TypeScript 3.0 Release Notes",
        },
        {
          title: "TypeScript 2.9",
          id: "5-typescript-2.9",
          permalink: "/zh/docs/handbook/release-notes/typescript-2-9.html",
          oneline: "TypeScript 2.9 Release Notes",
        },
        {
          title: "TypeScript 2.8",
          id: "5-typescript-2.8",
          permalink: "/zh/docs/handbook/release-notes/typescript-2-8.html",
          oneline: "TypeScript 2.8 Release Notes",
        },
        {
          title: "TypeScript 2.7",
          id: "5-typescript-2.7",
          permalink: "/zh/docs/handbook/release-notes/typescript-2-7.html",
          oneline: "TypeScript 2.7 Release Notes",
        },
        {
          title: "TypeScript 2.6",
          id: "5-typescript-2.6",
          permalink: "/zh/docs/handbook/release-notes/typescript-2-6.html",
          oneline: "TypeScript 2.6 Release Notes",
        },
        {
          title: "TypeScript 2.5",
          id: "5-typescript-2.5",
          permalink: "/zh/docs/handbook/release-notes/typescript-2-5.html",
          oneline: "TypeScript 2.5 Release Notes",
        },
        {
          title: "TypeScript 2.4",
          id: "5-typescript-2.4",
          permalink: "/zh/docs/handbook/release-notes/typescript-2-4.html",
          oneline: "TypeScript 2.4 Release Notes",
        },
        {
          title: "TypeScript 2.3",
          id: "5-typescript-2.3",
          permalink: "/zh/docs/handbook/release-notes/typescript-2-3.html",
          oneline: "TypeScript 2.3 Release Notes",
        },
        {
          title: "TypeScript 2.2",
          id: "5-typescript-2.2",
          permalink: "/zh/docs/handbook/release-notes/typescript-2-2.html",
          oneline: "TypeScript 2.2 Release Notes",
        },
        {
          title: "TypeScript 2.1",
          id: "5-typescript-2.1",
          permalink: "/zh/docs/handbook/release-notes/typescript-2-1.html",
          oneline: "TypeScript 2.1 Release Notes",
        },
        {
          title: "TypeScript 2.0",
          id: "5-typescript-2.0",
          permalink: "/zh/docs/handbook/release-notes/typescript-2-0.html",
          oneline: "TypeScript 2.0 Release Notes",
        },
        {
          title: "TypeScript 1.8",
          id: "5-typescript-1.8",
          permalink: "/zh/docs/handbook/release-notes/typescript-1-8.html",
          oneline: "TypeScript 1.8 Release Notes",
        },
        {
          title: "TypeScript 1.7",
          id: "5-typescript-1.7",
          permalink: "/zh/docs/handbook/release-notes/typescript-1-7.html",
          oneline: "TypeScript 1.7 Release Notes",
        },
        {
          title: "TypeScript 1.6",
          id: "5-typescript-1.6",
          permalink: "/zh/docs/handbook/release-notes/typescript-1-6.html",
          oneline: "TypeScript 1.6 Release Notes",
        },
        {
          title: "TypeScript 1.5",
          id: "5-typescript-1.5",
          permalink: "/zh/docs/handbook/release-notes/typescript-1-5.html",
          oneline: "TypeScript 1.5 Release Notes",
        },
        {
          title: "TypeScript 1.4",
          id: "5-typescript-1.4",
          permalink: "/zh/docs/handbook/release-notes/typescript-1-4.html",
          oneline: "TypeScript 1.3 Release Notes",
        },
        {
          title: "TypeScript 1.3",
          id: "5-typescript-1.3",
          permalink: "/zh/docs/handbook/release-notes/typescript-1-3.html",
          oneline: "TypeScript 1.3 Release Notes",
        },
        {
          title: "TypeScript 1.1",
          id: "5-typescript-1.1",
          permalink: "/zh/docs/handbook/release-notes/typescript-1-1.html",
          oneline: "TypeScript 1.1 Release Notes",
        },
      ],
    },
    {
      title: "Declaration Files",
      oneline:
        "Learn how to write declaration files to describe existing JavaScript. Important for DefinitelyTyped contributions.",
      id: "declaration-files",
      chronological: true,

      items: [
        {
          title: "介绍",
          id: "6-介绍",
          permalink: "/zh/docs/handbook/declaration-files/introduction.html",
          oneline: "如何编写高质量的 TypeScript 声明文件 (d.ts)",
        },
        {
          title: "声明文件参考",
          id: "6-声明文件参考",
          permalink: "/zh/docs/handbook/declaration-files/by-example.html",
          oneline: "如何为模块创建 d.ts 文件",
        },
        {
          title: "库结构",
          id: "6-库结构",
          permalink:
            "/zh/docs/handbook/declaration-files/library-structures.html",
          oneline: "如何组织你的 d.ts 文件",
        },
        {
          title: ".d.ts Templates",
          id: "6-.d.ts-templates",
          oneline: "undefined",
          chronological: false,

          items: [
            {
              title: "Modules .d.ts",
              id: "6-modules-.d.ts",
              permalink:
                "/zh/docs/handbook/declaration-files/templates/module-d-ts.html",
              oneline: "undefined",
            },
            {
              title: "Module: Plugin",
              id: "6-module:-plugin",
              permalink:
                "/zh/docs/handbook/declaration-files/templates/module-plugin-d-ts.html",
              oneline: "undefined",
            },
            {
              title: "模块：类",
              id: "6-模块：类",
              permalink:
                "/zh/docs/handbook/declaration-files/templates/module-class-d-ts.html",
              oneline: "undefined",
            },
            {
              title: "模块: 函数",
              id: "6-模块:-函数",
              permalink:
                "/zh/docs/handbook/declaration-files/templates/module-function-d-ts.html",
              oneline: "undefined",
            },
            {
              title: "Global .d.ts",
              id: "6-global-.d.ts",
              permalink:
                "/zh/docs/handbook/declaration-files/templates/global-d-ts.html",
              oneline: "undefined",
            },
            {
              title: "Global: Modifying Module",
              id: "6-global:-modifying-module",
              permalink:
                "/zh/docs/handbook/declaration-files/templates/global-modifying-module-d-ts.html",
              oneline: "undefined",
            },
          ],
        },
        {
          title: "Do's and Don'ts",
          id: "6-do's-and-don'ts",
          permalink: "/zh/docs/handbook/declaration-files/do-s-and-don-ts.html",
          oneline: "Recommendations for writing d.ts files",
        },
        {
          title: "深入探讨",
          id: "6-深入探讨",
          permalink: "/zh/docs/handbook/declaration-files/deep-dive.html",
          oneline: "深入解析 d.ts 文件如何工作",
        },
        {
          title: "发布",
          id: "6-发布",
          permalink: "/zh/docs/handbook/declaration-files/publishing.html",
          oneline: "如何向用户提供 d.ts 文件",
        },
        {
          title: "使用",
          id: "6-使用",
          permalink: "/zh/docs/handbook/declaration-files/consumption.html",
          oneline: "如何下载 .d.ts 文件以供你的项目使用",
        },
      ],
    },
    {
      title: "JavaScript",
      oneline: "How to use TypeScript-powered JavaScript tooling.",
      id: "javascript",
      chronological: true,

      items: [
        {
          title: "使用 TypeScript 来编写 JavaScript 项目",
          id: "7-使用-typescript-来编写-javascript-项目",
          permalink: "/zh/docs/handbook/intro-to-js-ts.html",
          oneline: "如何使用 TypeScript 向 JavaScript 添加类型检查",
        },
        {
          title: "JavaScript 文件的类型检查",
          id: "7-javascript-文件的类型检查",
          permalink: "/zh/docs/handbook/type-checking-javascript-files.html",
          oneline: "如何使用 TypeScript 为 JavaScript 文件添加类型检查",
        },
        {
          title: "JSDoc 参考",
          id: "7-jsdoc-参考",
          permalink: "/zh/docs/handbook/jsdoc-supported-types.html",
          oneline: "TypeScript 支持哪些 JSDoc 构造？",
        },
        {
          title: "为 .js 文件创建 .d.ts 文件",
          id: "7-为-.js-文件创建-.d.ts-文件",
          permalink: "/zh/docs/handbook/declaration-files/dts-from-js.html",
          oneline: "如何为 JavaScript 项目添加 d.ts 生成",
        },
      ],
    },
    {
      title: "Project Configuration",
      oneline: "Compiler configuration reference.",
      id: "project-configuration",
      chronological: false,

      items: [
        {
          title: "tsconfig.json 是什么",
          id: "8-tsconfig.json-是什么",
          permalink: "/zh/docs/handbook/tsconfig-json.html",
          oneline: "了解 TSConfig 的工作原理",
        },
        {
          title: "Compiler Options in MSBuild",
          id: "8-compiler-options-in-msbuild",
          permalink: "/zh/docs/handbook/compiler-options-in-msbuild.html",
          oneline: "Which compiler options are available in MSBuild projects.",
        },
        {
          title: "TSConfig Reference",
          id: "8-tsconfig-reference",
          permalink: "/tsconfig",
          oneline: "The page covering every TSConfig option",
        },
        {
          title: "tsc CLI Options",
          id: "8-tsc-cli-options",
          permalink: "/zh/docs/handbook/compiler-options.html",
          oneline:
            "A very high-level overview of the CLI compiler options for tsc",
        },
        {
          title: "Project References",
          id: "8-project-references",
          permalink: "/zh/docs/handbook/project-references.html",
          oneline: "How to split up a large TypeScript project",
        },
        {
          title: "与构建工具集成",
          id: "8-与构建工具集成",
          permalink: "/zh/docs/handbook/integrating-with-build-tools.html",
          oneline: "如何将 TypeScript 与其他构建工具一起使用",
        },
        {
          title: "Configuring Watch",
          id: "8-configuring-watch",
          permalink: "/zh/docs/handbook/configuring-watch.html",
          oneline: "How to configure the watch mode of TypeScript",
        },
        {
          title: "每日构建",
          id: "8-每日构建",
          permalink: "/zh/docs/handbook/nightly-builds.html",
          oneline: "如何使用TypeScript的每日构建版本",
        },
      ],
    },
  ];

  return navigations[lang];
}
